import { useEffect, useState } from 'react';
import { obtenerEjercicios } from '../services/apiService';

type Ejercicio = {
  id: string;
  nombre: string;
  estilo: string;
  nivel: string;
  grupoMuscular: string;
  imagenURL: string;
  activo: boolean;
};

export default function GaleriaEjercicios() {
  const [ejercicios, setEjercicios] = useState<Ejercicio[]>([]);
  const [estilo, setEstilo] = useState('');
  const [nivel, setNivel] = useState('');

  useEffect(() => {
    obtenerEjercicios()
      .then((data) => setEjercicios(data))
      .catch(() => console.error('❌ Error al cargar ejercicios'));
  }, []);

  const filtrados = ejercicios.filter((e) =>
    (!estilo || e.estilo === estilo) && (!nivel || e.nivel === nivel)
  );

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-center mb-6">📘 Galería de Ejercicios</h2>

      <div className="flex flex-wrap gap-4 justify-center mb-6">
        <div>
          <label className="font-medium">🎯 Estilo:</label>
          <select
            className="border rounded px-3 py-2 ml-2"
            value={estilo}
            onChange={(e) => setEstilo(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="calistenia">Calistenia</option>
            <option value="palestra">Palestra</option>
          </select>
        </div>

        <div>
          <label className="font-medium">🔥 Nivel:</label>
          <select
            className="border rounded px-3 py-2 ml-2"
            value={nivel}
            onChange={(e) => setNivel(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="principiante">Principiante</option>
            <option value="intermedio">Intermedio</option>
            <option value="avanzado">Avanzado</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {filtrados.map((e) => (
          <div key={e.id} className="bg-white shadow rounded-lg p-4 border border-gray-300">
            <img
              src={e.imagenURL}
              alt={e.nombre}
              className="w-full h-40 object-cover rounded mb-3"
            />
            <h4 className="text-lg font-bold">{e.nombre}</h4>
            <p className="text-sm text-gray-700 mt-1">
              <strong>Grupo:</strong> {e.grupoMuscular}<br />
              <strong>Estilo:</strong> {e.estilo}<br />
              <strong>Nivel:</strong> {e.nivel}
            </p>
            <button className="mt-3 bg-blue-600 hover:bg-blue-700 text-white py-1 px-3 rounded">
              Seleccionar
            </button>
          </div>
        ))}
      </div>

      {filtrados.length === 0 && (
        <p className="mt-6 text-center text-gray-600">No hay ejercicios que coincidan con los filtros.</p>
      )}
    </div>
  );
}
